
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';

interface OrganizationInputProps {
  organizationCode: string;
  setOrganizationCode: (code: string) => void;
  rememberOrganization: boolean;
  onRememberChange: (checked: boolean) => void;
}

const OrganizationInput: React.FC<OrganizationInputProps> = ({
  organizationCode,
  setOrganizationCode,
  rememberOrganization,
  onRememberChange
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="organizationCode">Organization Code</Label>
      <Input
        id="organizationCode"
        type="text"
        value={organizationCode}
        onChange={(e) => setOrganizationCode(e.target.value)}
        required
        placeholder="Enter your organization code (e.g. microsoft)"
      />
      <div className="flex items-center space-x-2">
        <Checkbox
          id="rememberOrganization"
          checked={rememberOrganization}
          onCheckedChange={onRememberChange}
        />
        <Label htmlFor="rememberOrganization" className="text-sm text-gray-600">
          Remember organization code
        </Label>
      </div>
    </div>
  );
};

export default OrganizationInput;
